// extracted by mini-css-extract-plugin
module.exports = {"root":"Summary_root__2q6cd","top":"Summary_top__pblcQ","split":"Summary_split__2yMWD","divider":"Summary_divider__UgEC4"};